import SubmenuColumns from './SubmenuColumns';

export default SubmenuColumns;
